<template>
    <div>
        <input-checkbox
            label="Debug Mode"
            label-class="text-gray-100"
            @change="toggleDebugMode"
        />
    </div>
</template>

<script>
import {useDebugStore} from "../stores/debug";
import InputCheckbox from "./form/InputCheckbox.vue";

export default {
    name: "DebugMode",
    components: {InputCheckbox},
    data() {
        return {
            debugStore: useDebugStore(),
        };
    },
    methods: {
        toggleDebugMode (value) {
            this.debugStore.debugMode = value;
        },
    },
};
</script>

